import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BUTTON_VARIANT } from '@manulife/mux';
import { FormattedRichMessage, CoBrandingButton, customStyles } from 'ciam-self-service-shared';

const ChannelButtonWrapper = styled.div`
  line-height: 1.25rem;
`;

const MFAChannelButton = (props) => {
  const { type, maskedValue, onClick, isLoading, url, ...otherProps } = props;

  const messageId = `mfa.${type}ChannelButton${maskedValue ? '.withMask' : ''}`;

  return (
    <div>
      <CoBrandingButton
        variant={BUTTON_VARIANT.SECONDARY}
        customStyle={customStyles.button}
        onClick={onClick}
        disabled={isLoading}
        saving={isLoading}
        analyticsData={{
          click: {
            linkName: maskedValue ? maskedValue : '',
            ...(url && { linkHref: url }),
          },
        }}
        data-testid="channel-select-btn"
        {...otherProps}
      >
        <ChannelButtonWrapper>
          <FormattedRichMessage
            id={messageId}
            values={{
              maskedValue,
            }}
          />
        </ChannelButtonWrapper>
      </CoBrandingButton>
    </div>
  );
};

MFAChannelButton.propTypes = {
  type: PropTypes.oneOf(['phone', 'email']).isRequired,
  onClick: PropTypes.func.isRequired,
  maskedValue: PropTypes.string,
  isLoading: PropTypes.bool,
};

MFAChannelButton.defaultProps = {
  maskedValue: '',
  isLoading: false,
};

export default MFAChannelButton;
